const mixin = {
  methods: {
    $_uploadImage_readImage(file) {
      return new Promise((resolve, reject) => {
        const imgValidate = this.$_uploadImage_validate(file.type);
        if (!imgValidate) {
          console.log("File type is not supported");
          reject();
        }
        if (typeof FileReader === "function") {
          const reader = new FileReader();
          reader.onload = event => {
            const imgSrc = event.target.result;
            resolve(imgSrc);
          };
          reader.readAsDataURL(file);
        } else {
          alert("Sorry, FileReader API not supported");
          reject();
        }
      });
    },
    $_uploadImage_validate(fileType) {
      return fileType.includes("image/");
    },
    // $_uploadImage_getRecentImages() {
    //   let cachedImages = getItemStorage(
    //     this.$constants.LOCAL_STORAGE_KEY__RECENT_IMAGES
    //   );
    //   return cachedImages ? JSON.parse(cachedImages) : [];
    // },
    // $_uploadImage_putToRecentImages(url) {
    //   let cachedImages = getItemStorage(
    //     this.$constants.LOCAL_STORAGE_KEY__RECENT_IMAGES
    //   );
    //   if (cachedImages) {
    //     cachedImages = JSON.parse(cachedImages);
    //   } else cachedImages = [];
    //   cachedImages.unshift(url);
    //   const imgCachedNum = cachedImages.length;
    //   if (imgCachedNum > this.$constants.LOCAL_STORAGE_MAX_IMAGES_CACHE) {
    //     cachedImages.splice(imgCachedNum - 1, 1);
    //   }
    //   setItemStorage(
    //     this.$constants.LOCAL_STORAGE_KEY__RECENT_IMAGES,
    //     JSON.stringify(cachedImages)
    //   );
    // },
    $_uploadImage_uploadImageToImgul(file) {
      // console.log("upload file to imgur");
      return new Promise((resolve, reject) => {
        const api = process.env.VUE_APP_IMGUR_POST_IMAGE_API;
        let formData = new FormData();
        formData.set("image", file.replace("data:image/png;base64,", ""));
        this.axios({
          method: "POST",
          url: api,
          data: formData,
          headers: {
            Authorization: process.env.VUE_APP_IMGUR_CLIENT_ID,
            "Content-Type": "multipart/form-data"
          }
        })
          .then(response => {
            // console.log("Upload imgur response: ", response.data);
            resolve(response.data);
          })
          .catch(error => {
            console.log("Upload imgur error: ", error);
            reject();
          });
      });
    },
    $_uploadImage_uploadImageToAdmin(file, fileName) {
      return new Promise((resolve, reject) => {
        let api =
          process.env.VUE_APP_ADMIN_API_URL +
          this.$constants.API.admin.file_upload;
        if (this.$store.getters.token) {
          api += "?user_token=" + this.$store.getters.token;
        }
        let formData = new FormData();
        formData.append("file", file, fileName);
        this.axios({
          method: "post",
          url: api,
          data: formData
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default mixin;
